import React from "react";
import { TextWithGlossary } from "./TextWithGlossary";
import parse from "html-react-parser";
import { useGlossaryStore } from "../stores/glossary.store";

export const ConceptsSection: React.FC = () => {
    const { terms } = useGlossaryStore();
    return (
        <div className="bg-gray-800 rounded-xl shadow-lg p-6 mt-8 listStyleDisc">
            <h3 className="text-lg font-semibold text-white mb-6">
                <TextWithGlossary>Glossário</TextWithGlossary>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {terms.map((glossary) => (
                    <div className="bg-gray-700/50 rounded-lg p-4" key={glossary.term}>
                        <div className="flex items-center gap-3 mb-3">
                            <img src={glossary.thumbnail.url} alt={glossary.thumbnail.alt} width={36} className="aspect-square" />
                            <h4 className="text-md font-medium text-white">
                                {glossary.term}
                            </h4>
                        </div>
                        <div className="text-sm text-gray-300 leading-relaxed">
                            <TextWithGlossary>{parse(glossary.definition)}</TextWithGlossary>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
